import BaseTrack from "./basetracks";
import {fromTimeToPixel, fromPixelToTime} from "../../../../../utils/timelineutils.js"

import imgFlagCheckST from "../assets/flags/checkst.png"
import imgFlagNewST from "../assets/flags/newst.png"
import { drawStabilo } from "../../../../../utils/colors.js";
import { getSubtitleErrorsInfos } from "../../../../../utils/checksubtitles.js";
import { getStabiloForTranscriptApp } from "../../../../../utils/checksubtitles.js";

import { V2_RoundedTimeCode } from "../../../../../utils/timecodev2.js";
import { V2_GetOneFrameDuration } from "../../../../../utils/timecodev2.js";

class STTrack extends BaseTrack
{
    constructor (type, datas, file1, file2, channel, id, parent)
    {
        super (type, datas, file1, file2, channel, id, parent);
        

        this.defaultHeight = 60;
        this.minHeight = 60;
        this.maxHeight = 100;

        this.ontopmost = false;
        this.ontop = false;
        this.onbottom = false;
        this.onbottommost = false;

        this.minimisable = true;

        this.height = this.defaultHeight;

        this.firstDrawSubtitle = -1;
        this.lastDrawSubtitle = -1;


        var style = getComputedStyle(document.body);
        this.backcolor = style.getPropertyValue('--timeline-sttrack-backcolor');        


        this.flagcheckSt = new Image();
        this.flagcheckSt.src = imgFlagCheckST;
        this.flagNewSt = new Image();
        this.flagNewSt.src = imgFlagNewST;

        this.currentSubtitle = -1;

        this.drawIconError = this.drawIconError.bind(this)
        
  }




    procheTime (tc, time)
    {
        return ((tc >= time-0.02) && (tc<=time+0.02));
    }


    moveSubtitle(time, shift)
    {
        if (!this.datasMove) return null;
        if (time < 0) return null;

        
        

        const startdraw = this.startDrawTime - this.parent.offsetTime();
        const enddraw = this.endDrawTime - this.parent.offsetTime();
        

        if (time < this.datasMove.lastTime)
        {
             //on recule 
            if (((time - startdraw) < 4) && (startdraw > 0))
                this.parent.decaleTime (time - this.datasMove.lastTime);
        }

        var onavance = false;
        if (time > this.datasMove.lastTime)
        {
            // on avance
            onavance = true;
            if (enddraw - time < 1)
                this.parent.decaleTime (time - this.datasMove.lastTime );
        }

        this.datasMove.shift = shift;
        this.datasMove.lastTime = time;

        var tcin = this.datas[this.datasMove.id].in;
        var tcout = this.datas[this.datasMove.id].out;
        switch (this.datasMove.type)
        {
            case "tcst":
                tcin = this.datasMove.tcin + (time - this.datasMove.startTime);
                tcout = this.datasMove.tcout + (time - this.datasMove.startTime);
                break;
            case "tcin":
                tcin = this.datasMove.tcin + (time - this.datasMove.startTime);
                break;
            case "tcout":
                tcout = this.datasMove.tcout + (time - this.datasMove.startTime);
                break;

        }


        if (!this.datasMove.shift)
        {
            // on fait des tests 
            var tcinmin = 0;
            var tcoutmax = this.parent.state.maxduration;
            const listcp = this.parent.listcp;


            if (this.datasMove.id != 0)
            {
                // on recherche le tcin mini par rapport au précédent
                tcinmin = this.datas[this.datasMove.id -1].out
                if (this.parent.paramsst)
                    tcinmin = tcinmin + this.parent.paramsst.interst;
            }

            if (listcp)
            {
                // on recherche le cp le plus proche de timecode in
                var tccp = -1;

                for (var i=0; i<listcp.length; i++)
                {
                    if ((listcp[i].time+this.parent.offsetTime()) <= this.datasMove.tcin)
                        tccp = listcp[i].time + +this.parent.offsetTime();
                    else
                        break;
                }
                if ((tccp != -1) && this.parent.paramsst)
                    tccp = tccp + this.parent.paramsst.aftercp;
                if ((tccp !== -1) && (tccp > tcinmin)) tcinmin = tccp;
            }



            if (this.datasMove.id < (this.datas.length - 1))
            {
                // on recherche le tcout max par rapport au suivant
                tcoutmax = this.datas[this.datasMove.id +1].in
                if (this.parent.paramsst)
                    tcoutmax = tcoutmax - this.parent.paramsst.interst;
            }


            if (listcp)
            {
                // on recherche le cp le plus proche de timecode in
                var tccp = -1;

                for (var i=listcp.length-1 ; i>=0 ; i--)
                {
                    if ((listcp[i].time+this.parent.offsetTime()) >= this.datasMove.tcout)
                        tccp = listcp[i].time+this.parent.offsetTime();
                    else
                        break;
                }
                if ((tccp != -1) && this.parent.paramsst)
                    tccp = tccp - this.parent.paramsst.beforecp;
                if ((tccp !== -1) && (tccp < tcoutmax)) tcoutmax = tccp;
            }

            const numden = this.parent.getCurrentNumDen();
            var mag = this.parent.props.timelineparams.magnetism;
            mag = mag * V2_GetOneFrameDuration(numden.num, numden.den);

            switch (this.datasMove.type)
            {
                case "tcin":
                    if (tcin <= tcinmin) tcin = tcinmin;

                    // on regarde le magnetisme


                    
                    if ((mag !==0) && (!onavance))
                    {
                        if (tcin <= tcinmin + mag)
                            tcin = tcinmin;
                    }



                    if (this.parent.paramsst) 
                        if ((tcout - tcin) < this.parent.paramsst.min)
                            return null;
                    break;
                case "tcout":

                    

                    
                    if ((mag !==0) && (onavance))
                    {
                        if (tcout >= tcoutmax - mag)
                            tcout = tcoutmax;
                    }



                    if (tcout >= tcoutmax) tcout = tcoutmax;
                    if (this.parent.paramsst) 
                        if ((tcout - tcin) < this.parent.paramsst.min)
                            return null;
                    break;
                case "tcst":
                    
                    if (tcin <= tcinmin) 
                    {
                        tcin = tcinmin;
                        tcout = tcin + (this.datasMove.tcout - this.datasMove.tcin);
                    }
                    
                    if (tcout >= tcoutmax) 
                    {
                        tcout = tcoutmax;
                        tcin = tcout - (this.datasMove.tcout - this.datasMove.tcin);
                    }

                    const duree = tcout - tcin;
                    if ((mag !==0) && (!onavance))
                    {

                        if (tcin <= tcinmin + mag)
                        {
                            tcin = tcinmin;
                            tcout = tcin + duree;
                        }

                    }

                    if ((mag !==0) && (onavance))
                    {

                        if (tcout >= tcoutmax - mag)
                        {
                            tcout = tcoutmax;
                            tcin = tcout-duree;
                        }

                    }


                    break;


            }

        }

        const numden = this.parent.getCurrentNumDen();
        const num = numden.num;
        const den = numden.den;
        this.datas[this.datasMove.id].in = V2_RoundedTimeCode(tcin,num,den);
        this.datas[this.datasMove.id].out = V2_RoundedTimeCode(tcout,num,den);
        this.datasMove.value1 = V2_RoundedTimeCode(tcin,num,den);
        this.datasMove.value2 = V2_RoundedTimeCode(tcout,num,den);

        return this.datasMove;

    }

    getMouseDbClick (time,shift, ctrl, alt)
    {
        const ret = this.getCursor(time)
        if (ret)
        {
            
            var tcin = ret.tcin;
            var tcout = ret.tcout;
            var nust = ret.id;
            const numden = this.parent.getCurrentNumDen();
            

            const fd = V2_GetOneFrameDuration(numden.num, numden.den);
            var xtype = "";
            var otime = time + this.parent.offsetTime();
            if (otime < (tcin + 4 * fd))
                xtype = "in";
            
            if (otime >= (tcout - 4 * fd))
                xtype = "out";

            const listcp = this.parent.listcp;
            switch (xtype)
            {
                case "in":
                    var tcinmin = 0;
                    if (nust != 0)
                    {
                        tcinmin = this.datas[nust-1].out;
                        if (this.parent.paramsst)
                            tcinmin = tcinmin + this.parent.paramsst.interst;
                    }
                    if (listcp)
                    {
                        // on recherche le cp le plus proche de timecode in
                        
                        var tccp = -1;

                        for (var i=0; i<listcp.length; i++)
                        {
                            if ((listcp[i].time+this.parent.offsetTime()) <= tcin)
                                tccp = listcp[i].time +this.parent.offsetTime();
                            else
                                break;
                        }
                        if ((tccp != -1) && this.parent.paramsst)
                            tccp = tccp + this.parent.paramsst.aftercp;
                        if ((tccp !== -1) && (tccp > tcinmin)) tcinmin = tccp;
                    }

                    // on regarde si c'est pas trop long
                    var max = 4;
                    if (this.parent.paramsst)
                        max = this.parent.paramsst.max;

                    if ((tcout - tcinmin) > max)
                        tcinmin = tcout - max;

                    tcinmin = V2_RoundedTimeCode(tcinmin,numden.num,numden.den);
                    

                    var datas  = {
                        id: nust,
                        type: "tcin",
                        value1: tcinmin,
                        value2: tcout,

                    }
                    if (this.parent.props.onChangeTimeCode) this.parent.props.onChangeTimeCode(datas);

                    break;

                case "out":
                    var tcoutmax = 24 * 60 * 60;
                    
                    if (nust != this.datas.length - 1)
                    {
                        tcoutmax = this.datas[nust+1].in;
                        if (this.parent.paramsst)
                            tcoutmax = tcoutmax - this.parent.paramsst.interst;
                        if (tcoutmax < 0) tcoutmax = 0;
                    }
                    if (listcp)
                    {
                        // on recherche le cp le plus proche de timecode out
                        
                        var tccp = -1;

                        for (var i= listcp.length - 1; i>=0 ; i--)
                        {
                            if ((listcp[i].time+this.parent.offsetTime()) >= tcout)
                                tccp = listcp[i].time + this.parent.offsetTime();
                            else
                                break;
                        }
                        if ((tccp != -1) && this.parent.paramsst)
                            tccp = tccp - this.parent.paramsst.beforecp;
                        if ((tccp !== -1) && (tccp < tcoutmax)) tcoutmax = tccp;
                    }

                    // on regarde si c'est pas trop long
                    var max = 4;
                    if (this.parent.paramsst)
                        max = this.parent.paramsst.max;

                    if ((tcoutmax - tcin) > max)
                        tcoutmax = tcin + max;

                    tcoutmax = V2_RoundedTimeCode(tcoutmax,numden.num,numden.den);
                    

                    var datas  = {
                        id: nust,
                        type: "tcout",
                        value1: tcin,
                        value2: tcoutmax,

                    }
                    if (this.parent.props.onChangeTimeCode) this.parent.props.onChangeTimeCode(datas);

                    break;



            }

        }

    }
    getMouseDown(time, shift, ctrl, alt)
    {

        if (ctrl)
        {
            if (alt) 
                this.parent.ondetectionButton("takeout", time, this.currentSubtitle);
            else
                this.parent.ondetectionButton("takein", time, this.currentSubtitle);
            return null;
        }
        const ret = this.getCursor(time)
        if (ret)
        {
            this.datasMove = ret;
            this.datasMove.shift = shift;
            this.datasMove.startTime = time;
            this.datasMove.lastTime = time;

        }
       return ret; 
    }

    getMouseUp(time = 0)
    {
        if (this.datasMove)
        {
            
            if (this.parent.props.onMouseUpOnSubtitle) this.parent.props.onMouseUpOnSubtitle(this.datasMove)
        /*
        // est-ce que l'on va réorganiser la liste
        // est-ce qu'on est avant le précedent
        if (currentSubtitleId !== 0)
        {
          if (subtitles[currentSubtitleId-1].in > subtitles[currentSubtitleId].in)
          {
            console.log("on inverse avec le précédent")
            var encours = cloneDeep(subtitles[currentSubtitleId])
            var prec = cloneDeep(subtitles[currentSubtitleId-1])
            subtitles[currentSubtitleId] = prec;
            subtitles[currentSubtitleId-1] = encours;
            subtitles[currentSubtitleId].id = currentSubtitleId;
            subtitles[currentSubtitleId-1].id = currentSubtitleId-1;
            currentSubtitleId = currentSubtitleId -1;
          }
        }
        */


        }
        this.datasMove = null;
        this.parent.recaleAll();
    }


    setNewST(newst)
    {
        const ind  = newst.id;

        if (ind >=0 && ind < this.datas.length)
            this.datas[ind] = newst;
    }

    getCursor(time)
    {
        time = time + this.parent.offsetTime();
        if (this.type !=="st") return null; // on fait rien sur les st originaux
        if (this.datasMove) return this.moveSubtitle(time); // on fait rien, un déplacement est en cours
        if (this.firstDrawSubtitle === -1) return null;

        var ret = null;

        for (var ind = this.firstDrawSubtitle; ind <= this.lastDrawSubtitle; ind++)
        {

            const tcin = this.datas[ind].in;
            const tcout = this.datas[ind].out;


            if (this.procheTime(tcin, time )) return {id: ind,type:"tcin", value1:tcin, value2:0, cursor:"ew-resize", tcin:tcin, tcout:tcout};
            if (this.procheTime(tcout, time )) return {id: ind,type:"tcout", value1:0, value2:tcout, cursor:"ew-resize", tcin:tcin, tcout:tcout};


            if ((time > tcin) && (time < tcout))
            {
                //if (this.parent) this.parent.getCpListFromTrack();

                // pointer
                var cutype = "pointer";
                const numden = this.parent.getCurrentNumDen();
                const fd = V2_GetOneFrameDuration(numden.num, numden.den)

                if (time < (tcin + 4 * fd))
                    cutype = "cell";
                
                if (time >= (tcout - 4 * fd))
                    cutype = "cell";

                return  {id: ind, type:"tcst", cursor:cutype, value1:tcin, value2:tcout, tcin:tcin, tcout:tcout};
            }



        }
        return null;


        
    }


    isFixedHeight()
    {
        return false;
    }



    chargerImage(url) 
    {
        return new Promise((resolve, reject) => {
            const img = new Image();

            
            img.onload = () => 
            {

                resolve(img);     // Résout quand chargée
            }
            img.onerror = (err) => reject(err);  // Rejette en cas d'erreur

            img.src = url;
    });
    }

    drawIconError(icon, context,decalex,xpos,ystart)
    {
        return;
    }


    async redrawbackgroundLevel1(context, width, currentTime, sTimeCode, starttime, duration,fullheight, ystart)
    {

        if (width <=0) return;
        super.redrawForeGround(context,width);

        starttime = starttime + this.parent.offsetTime();
        

        this.startDrawTime = Math.floor(starttime) -1;
        if (this.startDrawTime< 0) this.startDrawTime = 0;
        this.endDrawTime = this.startDrawTime + duration + 2;



        var cont = true;
        var ind = 0;

        this.firstDrawSubtitle = -1;
        this.lastDrawSubtitle = -1;

        const yheight = this.height - 14;
        const tempCanvas = document.createElement("canvas");
        var tempCtx = tempCanvas.getContext("2d");

        var foundFontSize = false;
        var subtitleFontSize = 7;
        const maxfontsize = 50;
        var checkfontsize = 7;
        const hline = yheight/2 - 2;
        while ((!foundFontSize) && (checkfontsize < maxfontsize))
        {

            tempCtx.font = checkfontsize.toString()+"px Arial";
            const metrics = tempCtx.measureText("|") ;
            const height = metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent ;
            
            if (height < hline )
            {
                subtitleFontSize = checkfontsize;
                checkfontsize++;
            }
            else
                foundFontSize=true;

        }


        var options =  {
            radius: 6,
            fillStyle : "#000000",
            strokeStyle : "#404040",
            lineWidth :1,
            strokeAlign : 'inside'
            }
        


        while (cont)
        {
            if (ind >= this.datas.length)
                cont = false;
            else
            {
                if (this.datas[ind].out < this.startDrawTime)
                    cont = true;
                else
                {
                    if (this.datas[ind].in> this.endDrawTime)
                        cont= false;
                    else
                    {
                        // ici on peut dessiner le mot

                        const stimecodein =  (ind+1).toString()+" " + this.parent.getTimeCodeStringNoOffset(this.datas[ind].in);
                        const stimecodeout =  this.parent.getTimeCodeStringNoOffset(this.datas[ind].out);

                        if (this.firstDrawSubtitle === -1) this.firstDrawSubtitle = ind;
                        this.lastDrawSubtitle = ind;


                        context.textBaseline = 'top';
                        context.font = "9px courier new";
                        context.fillStyle="White";



                

                        
                        var xpos = fromTimeToPixel(this.datas[ind].in, width, starttime, duration);
                        var xposfin = fromTimeToPixel(this.datas[ind].out, width, starttime, duration);


                        if (xposfin > xpos)
                        {
                        context.fillText(stimecodein,xpos,this.baseline);
                        context.fillText(stimecodeout,xposfin - context.measureText(stimecodeout).width,this.baseline);
                        

                        const ystart = this.baseline + 10;


                        var ligs =[];
                        var colors=[];


                        var nblst = 0;
                        if ('lines' in this.datas[ind])
                            nblst = this.datas[ind].lines.length;
                        for (var l=0; l < nblst; l++)
                        {
                            const nbwords = this.datas[ind].lines[l].words.length;
                            ligs[l] = "";
                            for (var m=0; m < nbwords; m++)
                            {
                                if (m != 0) 
                                    ligs[l] = ligs[l] + " ";
                                else
                                {
                                    colors[l] = this.datas[ind].lines[l].words[m].color;
                                    if (this.type === "oldst")
                                        colors[l] = this.assombrirCouleur(colors[l]);

                                }

                                ligs[l] = ligs[l] + this.datas[ind].lines[l].words[m].text;
                            }
                        }

                        

                        tempCtx.textBaseline = 'bottom';
                        
                        
                        const largeurCanvas  = xposfin - xpos;
                        

                        tempCtx.font = subtitleFontSize.toString()+"px Arial";
                        var largeurMax = 0;
                        for (l=0; l < nblst; l++)
                            if (tempCtx.measureText(ligs[l]).width > largeurMax) largeurMax = tempCtx.measureText(ligs[l]).width;

                        largeurMax += 20;
                        if (largeurCanvas > largeurMax) largeurMax=largeurCanvas;


                        tempCanvas.width = largeurMax;
                        tempCanvas.height = yheight;

                        tempCtx.fillStyle = this.backcolor;

                        options.lineWidth = 1;

                        if (ind === this.currentSubtitle)
                        {
                            //options.fillStyle = "#4B5D3A";
                            //options.strokeStyle = "#B7D36B";
                            options.fillStyle = "#4A4458";
                            options.strokeStyle = "#B8A9D9";
                        }
                        else
                        {
                            options.fillStyle = "#3A3A3A";
                            options.strokeStyle = "#5A5A5A";
                        }

                        if ((this.parent.props.type === "transcription") && (this.type === "st"))
                        {
                            if (this.datas[ind].computedError)
                            {
                                options.strokeStyle = this.datas[ind].computedColor;
                                options.lineWidth = 2;
                            }
                        }

                        

                        if ((this.datas[ind].selected) &&  (this.type === "st"))
                        {
                            tempCtx.setLineDash([4, 2]);
                            options.strokeStyle = "#FFFFFF";
                        }


                        this.drawRoundedRect(tempCtx, 0, 0, largeurMax, yheight-1, options);

                        tempCtx.setLineDash([]);


                        if ( ind === this.currentSubtitle)
                        {
                            
                            if (this.parent.props.timelineparams.displayFrame)
                            {
                                const numden = this.parent.getCurrentNumDen();
                                const onef = V2_GetOneFrameDuration(numden.num,numden.den);

                                const dureest = this.datas[ind].out - this.datas[ind].in;
                                if ((dureest > onef) && (largeurMax > 0))
                                {
                                    const nbframe = dureest / onef;
                                    const onefd = largeurMax / nbframe;

                                    var xpos2 = onefd ;

                                    for (var t = 1; t <= (nbframe-1); t++)
                                    {
                                    // on dessine des petits ronds /2 

                                        tempCtx.beginPath();
                                        tempCtx.moveTo(xpos2, yheight - 6);   // Point 1
                                        tempCtx.lineTo(xpos2 + onefd/2 - 2, yheight-3);   // Point 2
                                        tempCtx.lineTo(xpos2- onefd/2 + 2, yheight-3);  // Point 3
                                        tempCtx.closePath();       // Ferme le triangle

                                        tempCtx.fillStyle = "#606060";
                                        tempCtx.fill();
                                        xpos2 += onefd;
                                    }
                            }
                        }
                        }
                        // gestion de la lisibilité
                        if ((this.parent.props.type === "subtitling") && (this.type === "st"))
                        {
                            
                            if (("lisibility" in this.datas[ind]) && (this.datas[ind].lisibility))
                            {
                                
                                if (this.datas[ind].lisibility.color !=="black")
                                {
                                    var firstindexword = -1;
                                    var tcinst = 0;
                                    
                                    const st = this.datas[ind];

                                    if (st.lines[0].words.length !== 0)
                                    {
                                        tcinst = st.lines[0].words[0].in;
                                        firstindexword = st.lines[0].words[0].index;
                                    }
                                    else
                                    {
                                    if (st.lines[1] && st.lines[1].words.length !== 0)
                                        {
                                            tcinst = st.lines[1].words[0].in;
                                            firstindexword = st.lines[1].words[0].index;
                                        }
                                    }

                                    if (firstindexword !== -1) 
                                    {
                                        const rect = {
                                            x: 4,
                                            y: 6,
                                            width: largeurMax - 8,
                                            height: yheight - 12,
                                        
                                        }
                                        drawStabilo(tempCtx, st.lisibility.color, rect);
                                    }
                                }
                            }
                        }



                        // cas des sous titre en reatrd
                        if ((this.parent.props.type === "transcription") && (this.type === "st"))
                        {
                            

                            var firstindexword = -1;
                            var tcinst = 0;
                            
                            const st = this.datas[ind];

                            if (st.lines[0].words.length !== 0)
                            {
                                tcinst = st.lines[0].words[0].in;
                                firstindexword = st.lines[0].words[0].index;
                            }
                            else
                            {
                            if (st.lines[1].words.length !== 0)
                                {
                                    tcinst = st.lines[1].words[0].in;
                                    firstindexword = st.lines[1].words[0].index;
                                }
                            }

                            if (firstindexword !== -1) 
                            {
                                const deca = st.in - tcinst ;
                                const stab = getStabiloForTranscriptApp(deca);
                                if (stab.stabilo > 0)
                                {


                                    const rect = {
                                        x: 4,
                                        y: 6,
                                        width: largeurMax - 8,
                                        height: yheight - 12,
                                    
                                    }
                                    drawStabilo(tempCtx, stab.color, rect);
                                }
                            }
                        }



                        tempCtx.font = subtitleFontSize.toString()+"px Arial";

                        tempCtx.textBaseline = 'bottom';
                        

                        var yline = yheight;
                        for (l = nblst -1 ; l >= 0; l--)
                        {
                            tempCtx.fillStyle = colors[l];
                            tempCtx.fillText(ligs[l], largeurMax/2 - tempCtx.measureText(ligs[l]).width/2, yline);
                            yline = yline - yheight/2;
                        }



                            if (yheight > 1) 
                                context.drawImage(tempCanvas, 0,0,largeurMax,yheight,xpos, ystart,largeurCanvas,yheight);

                        var decalex=5;
                        if (this.datas[ind].mark & 1) 
                        {
                            context.drawImage(this.flagcheckSt,xpos-5 + decalex,ystart+yheight-16,14,14);
                            decalex+=22;
                        }
                        if (this.datas[ind].mark & 2) 
                        {
                            context.drawImage(this.flagNewSt,xpos-5 + decalex,ystart+yheight-16,14,14);
                            decalex +=22;
                        }

                        if ((this.parent.props.type === "subtitling") && (this.type === "st") && (false))
                        {
                            decalex=0;
                            const errors = getSubtitleErrorsInfos(this.datas[ind]);
                            if (errors.icons.length)
                            {
                                for (var e=0; e < errors.icons.length; e++)
                                {
                                    if ((decalex+20) <= largeurCanvas)
                                    {


                                        try{

                                        }
                                        catch(e)
                                        {
                                            alert(e)
                                        }

                                        
                                        decalex+=22;
                                    }
                                    else
                                        break;
                                }
                            }
                        }
                    }


                    }


                }
            }

            ind++;
        }

    }

    

    
}

export default STTrack;